import { Dialog, DialogActions, DialogBody, DialogTitle } from '@/components/catalyst-ui/dialog'
import { Button } from '@/components/catalyst-ui/button'
import { CheckBadgeIcon, XMarkIcon } from '@heroicons/react/24/solid'

export default function DomainConnectedSuccessDialog({
  open,
  onClose,
  heading,
  cancelLabel = 'Cancel',
  primaryLabel = 'Go to project',
  onPrimary,
}) {
  return (
    <Dialog open={open} onClose={onClose} className="!rounded-xl !p-5">
      <div className="flex justify-end">
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="-mt-2.5 -mr-2.5 rounded-md p-1 cursor-pointer hover:text-[#09090B] transition-colors outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>
      <DialogBody className="!mt-2 !flex items-center justify-center">
        <div className="flex flex-col items-center text-center space-y-4 max-w-[27rem]">
          <CheckBadgeIcon className="w-10 h-10 text-[#15803D]" />
          <div>
            <DialogTitle className="!text-lg !font-semibold !text-gray-900">
              {heading}
            </DialogTitle>
          </div>
        </div>
      </DialogBody>
      <DialogActions className="!mt-4">
        <Button
          outline
          className="!w-full data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
          onClick={onClose}
        >
          {cancelLabel}
        </Button>
        <Button
          color="dark"
          onClick={onPrimary}
          className="!w-full data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
        >
          {primaryLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
